import React from "react";
import { Reveal } from "../lib/anim";
import { METHOD } from "../data/content";

const Method = () => (
  <section id="methode" data-testid="method-section" className="py-24 lg:py-40 border-t border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="mb-20 max-w-2xl">
        <Reveal><p className="eyebrow mb-6">Notre méthode de travail</p></Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F5F5F0]">
            Du concept à <span className="italic gold-text">l'émotion</span>.
          </h2>
        </Reveal>
      </div>

      <div className="space-y-0">
        {METHOD.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.06}>
            <div
              data-testid={`method-step-${i}`}
              className="group grid lg:grid-cols-12 gap-6 lg:gap-12 items-baseline py-10 lg:py-12 border-t border-white/10 hover:border-[#D4AF37]/40 transition-colors duration-500"
            >
              <div className="lg:col-span-3">
                <span className="font-serif text-6xl lg:text-8xl text-[#D4AF37]/25 group-hover:text-[#D4AF37] transition-colors duration-500">
                  {m.n}
                </span>
              </div>
              <div className="lg:col-span-4">
                <h3 className="font-serif text-3xl lg:text-4xl text-[#F5F5F0]">{m.title}</h3>
              </div>
              <div className="lg:col-span-5">
                <p className="text-[#A1A1AA] text-lg leading-relaxed">{m.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Method;
